import { ContractVersionPageContractVersionFragment } from 'generated/resources/graphql'

export const getContractTypeName = (
  contractVersion: ContractVersionPageContractVersionFragment
): string | null => {
  switch (contractVersion.country) {
    case 'es':
      return contractVersion.spainContractType?.name ?? null
    case 'fr':
      return contractVersion.franceContractType?.name ?? null
    case 'de':
      return contractVersion.germanyContractType?.name ?? null
    case 'pt':
      return contractVersion.portugalContractType?.name ?? null
    default:
      return null
  }
}
